import styled from 'styled-components';

import { device } from '../../config/sizes';
import { appColors } from '../../config/colors';

export const ContentWrapper = styled.main`
  padding: 1em;
  padding-top: 8em;
  display: flex;
  justify-content: center;
`;

export const ContentArea = styled.div`
  max-width: 830px;
  width: 100%;

  [id]::before {
    content: '';
    display: block;
    height: 10rem;
    margin-top: -10rem;
    visibility: hidden;
  }

  img {
    width: 100%;
    border: 0.1px solid ${appColors.border};
    box-shadow: 6px 7px 0px 0px ${appColors.shadow};
  }

  figure {
    margin: 3em 0;

    @media ${device.tablet} {
      margin: 2em 2em 3em;
    }
  }

  figcaption {
    margin-top: 0.5em;
    font-size: 0.85em;
    color: ${appColors.fontSecondary};
  }

  video {
    max-width: 900px;
    width: 100%;
    border: 0.1px solid ${appColors.border};
    box-shadow: 6px 7px 0px 0px ${appColors.shadow};
  }
`;
